var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Supported API functions")]),_c('hr'),_c('v-card-text',[_vm._v("Currently the GeoAd API is on 1.0 version and supports 2 functions:")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }